enum TableFieldTypes {
  Text = 'text',
  Number = 'number',
  Checkbox = 'checkbox',
}

export default TableFieldTypes;
